import { Box, Button, Link, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

import GoLogo from '@/components/GoLogo';
import DefaultLayout from '@/layouts/DefaultLayout';

const SubscriptionSuccess = () => {
  const navigate = useNavigate();
  return (
    <DefaultLayout>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          mt: '8%'
        }}
      >
        <GoLogo size={64} />
        <Typography sx={{ fontSize: 36, fontWeight: 700, mb: 3, mt: 4 }}>
          Welcome to GX Go!
        </Typography>
        <Typography sx={{ fontSize: 16, maxWidth: 374, textAlign: 'center' }}>
          Providing the fastest, most accessible and integration-friendly platform for commodity
          pricing data.
        </Typography>
        <Button
          sx={{
            my: 4,
            fontSize: 18,
            width: 300
          }}
          variant='contained'
          onClick={() => {
            navigate('/markets');
          }}
        >
          Get started
        </Button>
        <Typography sx={{ fontSize: 16 }}>
          Any issues? Drop us a line at{' '}
          <Link
            color='text.primary'
            href='mailto:support@general-index.com'
            target='_top'
          >
            support@general-index.com
          </Link>
        </Typography>
      </Box>
    </DefaultLayout>
  );
};
export default SubscriptionSuccess;
